import { useUnsubscribeRingcentralEmailMutation } from '@pba/react-network';
import { useEffect } from 'react';
import { AxiosErrorHandler, Col, Icon, Loading, Row, Text, Title } from 'ui';

type P = {
  token?: string;
};

const Unsubscribe = ({ token }: P) => {
  const { error, isPending, mutate: unsubscribe } = useUnsubscribeRingcentralEmailMutation();

  useEffect(() => {
    if (token) {
      unsubscribe({ token });
    }
  }, [token, unsubscribe]);

  if (isPending) {
    return <Loading />;
  }

  return (
    <AxiosErrorHandler error={error}>
      <Row align="middle" justify="center">
        <Col>
          <Icon icon="sad-face" />
          <Title level={2} marginBottom>
            We are sad to see you go!
          </Title>
          <Text>You have successfully unsubscribed, you will no longer receive this type of emails.</Text>
        </Col>
      </Row>
    </AxiosErrorHandler>
  );
};

export default Unsubscribe;
